<div class="container-fluid">
	<div class="row align-items-center mx-0">
		<div class="col">
			<h1 class="py-3 text-capitalize">Ordenes De Compra</h1>
		</div>
		<div class="col-auto">
			<button type="button" *ngIf="rest.current_permission.add_purchases && purchase_search.eq.provider_user_id" class="btn btn-secondary" [routerLink]="['/purchase/provider',purchase_search.eq.provider_user_id]">Agregar</button>
			<button type="button" *ngIf="rest.current_permission.add_purchases && !purchase_search.eq.provider_user_id" class="btn btn-secondary" [routerLink]="['/purchase']">Agregar</button>
		</div>
	</div>

	<div class="card p-3">
		<div class="row">
			<div class="col-6 col-md-4 form-group">
				<label class="">Proveedor</label>
				<select name="provider_user_id" [(ngModel)]="purchase_search.eq.provider_user_id" class="form-control">
					<option [value]="null">Todos</option>
					<option *ngFor="let provider of provider_list" [value]="provider.id">{{provider.name}}</option>
				</select>
			</div>
			<div class="col-6 col-md-4 form-group">
				<label class="">Sucursal</label>
				<select name="store_id" [(ngModel)]="purchase_search.eq.store_id" class="form-control">
					<option [value]="null">Todos</option>
					<option *ngFor="let store of store_list" [value]="store.id">{{store.name}}</option>
				</select>
			</div>
			<div class="col-6 col-md-4 form-group">
				<label class="">Estatus pago</label>
				<select name="paid_status" [(ngModel)]="purchase_search.search_extra.paid_status" class="form-control">
					<option [value]="null">Todos</option>
					<option value="PAID">Pagado</option>
					<option value="PENDING">Pendiente</option>
				</select>
			</div>
			<div class="col-6 col-md-4 form-group">
				<label class="">Fecha inicial</label>
				<input type="datetime-local" name="search_start" [(ngModel)]="search_start" (ngModelChange)="onDateChange($event, purchase_search.ge, 'created')" class="form-control">
			</div>
			<div class="col-6 col-md-4 form-group">
				<label class="">Fecha final</label>
				<input type="datetime-local" name="search_end" [(ngModel)]="search_end" (ngModelChange)="onDateChange($event, purchase_search.le, 'created')" class="form-control">
			</div>
			<div class="col-6 col-md-4 form-group">
				<label>&nbsp;</label>
				<button type="button" class="w-100 btn btn-primary" (click)="search(purchase_search)">Buscar</button>
			</div>
		</div>
	</div>

	<div  class="card p-3 mt-3">
		<app-loading [is_loading]="is_loading"></app-loading>
		<div class="table-responsive">
			<table class="table table-sm table-nowrap mb-0">
				<thead class="thead-light">
					<tr>
						<th>Proveedor</th>
						<th>Sucursal</th>
						<th>Total</th>
						<th>Folio</th>
						<th>Estatus</th>
						<th>Creación</th>
						<th>Última edición</th>
						<th class="text-end">Acciones</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let purchase_info of purchase_info_list">
						<td>
							<a [routerLink]="['/purchase/edit',purchase_info.purchase.id]">
								{{purchase_info.purchase.id}} - {{purchase_info.purchase.provider_name }}
							</a>
						</td>
						<td>{{purchase_info.store.name  | titlecase }}</td>
						<td>{{purchase_info.purchase.total | currency }} {{purchase_info.bill.currency_id}}</td>
						<td>{{purchase_info.bill.folio}}</td>
						<td>
							<span *ngIf="purchase_info.bill.paid_status == 'PAID'">
								[Pagado]
							</span>
							<span>
								{{ purchase_info.purchase.stock_status == 'SHIPPING_CREATED' ? 'Envio Creado':''}}
								{{ purchase_info.purchase.stock_status == 'ADDED_TO_STOCK' ? 'Agregado a Inventario':''}}
							</span>
						</td>
						<td>
							<abbr title="{{purchase_info.purchase.created | shortDate: 'relative' }}">{{purchase_info.purchase.created | date: 'MMM d, y' }}</abbr>
						</td>
						<td>
							<abbr title="{{purchase_info.purchase.updated | shortDate: 'relative' }}">{{purchase_info.purchase.updated | date: 'MMM d, y' }}</abbr>
						</td>
						<td class="text-end">
							<a [routerLink]="['/print-purchase',purchase_info.purchase.id]" class="btn btn-primary mx-1" title="Imprimir Orden de Compra">
								<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" width="1em" height="1em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 28 28"><g fill="none"><path d="M7.004 5.765V7H6a4 4 0 0 0-4 4v7a3 3 0 0 0 3 3h2v1a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3v-1h2a3 3 0 0 0 3-3v-7a4 4 0 0 0-4-4h-1V5.752a2.75 2.75 0 0 0-2.754-2.75l-8.496.013a2.75 2.75 0 0 0-2.746 2.75zM19.5 5.752V7H8.504V5.765c0-.69.558-1.249 1.248-1.25l8.496-.013a1.25 1.25 0 0 1 1.252 1.25zM10 15.5h8a1.5 1.5 0 0 1 1.5 1.5v5a1.5 1.5 0 0 1-1.5 1.5h-8A1.5 1.5 0 0 1 8.5 22v-5a1.5 1.5 0 0 1 1.5-1.5z" fill="currentColor"/></g></svg>
							</a>
							<button type="button" class="btn btn-danger mx-1" (click)="deletePurchase(purchase_info)" *ngIf="purchase_info.purchase.stock_status == 'PENDING' && !purchase_info.shipping && rest.current_permission.add_purchases">
								Eliminar
							</button>
							<button type="button" class="btn btn-primary mx-1" (click)="showCreateShipping(purchase_info)" *ngIf="purchase_info.purchase.stock_status == 'PENDING' && (rest.current_permission.add_purchases || rest.current_permission.global_send_shipping)">
								Crear Envio
							</button>
							<button type="button" class="btn btn-primary mx-1" (click)="addToStock(purchase_info)" *ngIf="purchase_info.purchase.stock_status == 'PENDING' && (rest.current_permission.add_stock || rest.current_permission.global_add_stock)">
								Ingresar Inventario
							</button>
							<a  class="btn btn-primary" *ngIf="purchase_info.shipping"  [routerLink]="['/view-shipping',purchase_info.shipping.id]">Envío</a>
							<button type="button" class="btn btn-primary mx-1" (click)="openPaymentModal(purchase_info)" *ngIf="purchase_info.bill.paid_status !== 'PAID' && rest.current_permission.add_payments">
								Pagar
							</button>
						</td>
					</tr>
					<tr *ngIf="purchase_info_list.length == 0 && !is_loading" colspan="5">
						<td class="text-center">No se encontraron elementos</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
	<app-pagination [path]="'/list-purchase'" [pages]="pages" [total_pages]="total_pages" [current_page]="current_page"></app-pagination>
</div>
<app-modal [(show)]="show_create_shipping">
	<form (ngSubmit)="createShipping($event)" ngNativeValidate>
		<div class="row align-items-center p-3">
			<div class="col-12 col-md-6">
				<label class=""># Económico o Guía</label>
				<input type="text" name="shipping_guide" [(ngModel)]="shipping_guide" placeholder="xxxxxx" class="form-control" required>
			</div>
			<div class="col-12 col-md-6">
				<label class="">Nombre chofer/Paqueteria</label>
				<input type="text" name="shipping_company" [(ngModel)]="shipping_company" placeholder="Jesus martinez" class="form-control" required>
			</div>
			<div class="col-12 col-md-6">
				<label class="">Fecha de envío</label>
				<input type="date" name="shipping_date" [(ngModel)]="shipping_date" class="form-control" placeholder="YYYY-mm-dd" required>
			</div>
			<!--div class="col-6 col-md-4">
				<label class="">Received by user</label>
				<input type="number" name="received_by_user_id" [(ngModel)]="shipping_info.shipping.received_by_user_id" class="form-control">
			</div-->
			<div class="col-12 col-md-6">
				<div class="form-check form-switch">
					<input name="mark_shipping_as_send" class="form-check-input" type="checkbox" id="mark_as_sent" (change)="markAsSentChange($event)" [checked]="mark_as_sent">
					<label class="form-check-label" for="mark_as_sent">Marcar Como enviado</label>
				</div>
			</div>
		</div>
		<div class="row p-3">
			<div class="d-none d-md-flex col-md-6">
			</div>
			<div class="col-6 col-md-3">
				<button type="button" class="btn btn-primary w-100" (click)="show_create_shipping=false">Cancelar</button>
			</div>
			<div class="col-6 col-md-3">
				<button type="submit" class="btn btn-primary w-100">Crear Envio</button>
			</div>
		</div>
	</form>
</app-modal>

<app-modal [(show)]="show_batch_entry" [biggest_posible]="true">
	<div class="p-3">
		<h4>Información de Lotes</h4>
		<p class="text-muted">Los siguientes artículos requieren información de lote/caducidad.</p>

		<div *ngFor="let entry of batch_entries" class="card mb-3">
			<div class="card-header">
				<strong>{{entry.item.name}}</strong>
				<span class="badge bg-secondary ms-2">{{entry.batch_option}}</span>
				<span class="float-end">Cantidad total: {{entry.total_qty}} | Capturado: {{getTotalBatchQty(entry)}}</span>
			</div>
			<div class="card-body">
				<div class="table-responsive">
					<table class="table table-sm">
						<thead>
							<tr>
								<th *ngIf="entry.batch_option === 'BATCH_ONLY' || entry.batch_option === 'BATCH_AND_EXPIRATION'">Lote</th>
								<th *ngIf="entry.batch_option === 'EXPIRATION_ONLY' || entry.batch_option === 'BATCH_AND_EXPIRATION'">Fecha Caducidad</th>
								<th>Cantidad</th>
								<th></th>
							</tr>
						</thead>
						<tbody>
							<tr *ngFor="let row of entry.rows; let i = index">
								<td *ngIf="entry.batch_option === 'BATCH_ONLY' || entry.batch_option === 'BATCH_AND_EXPIRATION'">
									<input type="text" class="form-control form-control-sm" [(ngModel)]="row.batch" placeholder="Código de lote">
								</td>
								<td *ngIf="entry.batch_option === 'EXPIRATION_ONLY' || entry.batch_option === 'BATCH_AND_EXPIRATION'">
									<input type="date" class="form-control form-control-sm" [(ngModel)]="row.expiration_date">
								</td>
								<td>
									<input type="number" class="form-control form-control-sm" [(ngModel)]="row.qty" min="0" [step]="entry.item.partial_sale == 'NO' ? 'any' : '1'">
								</td>
								<td>
									<button type="button" class="btn btn-sm btn-danger" (click)="removeBatchRow(entry, i)" [disabled]="entry.rows.length === 1">
										<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
											<path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/>
											<path fill-rule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/>
										</svg>
									</button>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<button type="button" class="btn btn-sm btn-secondary" (click)="addBatchRow(entry)">+ Agregar Lote</button>
			</div>
		</div>

		<div class="row mt-3">
			<div class="col-6">
				<button type="button" class="btn btn-secondary w-100" (click)="cancelBatchEntry()">Cancelar</button>
			</div>
			<div class="col-6">
				<button type="button" class="btn btn-primary w-100" (click)="submitBatchEntry()">Continuar</button>
			</div>
		</div>
	</div>
</app-modal>

<app-modal [(show)]="show_payment_modal" [biggest_posible]="true">
	<app-pay-bills
		[bill_list]="billAsList()"
		[provider]="selected_purchase_for_payment?.provider || null"
		[store_id]="selected_purchase_for_payment?.purchase?.store_id || null"
		(paymentCreated)="onPaymentCreated()">
	</app-pay-bills>
</app-modal>
